import {
    UPDATE_SIGNUP_PARAMS,
    SUBMIT_SIGNUP_ERROR,
    SUBMIT_SIGNUP_SUCCESS,
    SUBMIT_SIGNUP_START,
    SEND_EMAIL_VERIFICATION_SUCCESS,
    SEND_EMAIL_VERIFICATION_START,
    SEND_EMAIL_VERIFICATION_ERROR,
} from "../reducers/signupContextReducer";

const updateSignupParams = params => ({
    type: UPDATE_SIGNUP_PARAMS,
    payload: params,
});

const signupSubmitStart = () => ({
    type: SUBMIT_SIGNUP_START,
});

const signupSubmitSuccess = () => ({
    type: SUBMIT_SIGNUP_SUCCESS,
});

const signupSubmitError = error => ({
    type: SUBMIT_SIGNUP_ERROR,
    payload: error,
});

const sendVerifyEmailStart = () => ({
    type: SEND_EMAIL_VERIFICATION_START,
});

const sendVerifyEmailSuccess = () => ({
    type: SEND_EMAIL_VERIFICATION_SUCCESS,
});

const sendVerifyEmailError = error => ({
    type: SEND_EMAIL_VERIFICATION_ERROR,
    payload: error,
});

export {
    updateSignupParams,
    signupSubmitStart,
    signupSubmitSuccess,
    signupSubmitError,
    sendVerifyEmailStart,
    sendVerifyEmailSuccess,
    sendVerifyEmailError,
};
